<div class="le-component">
  <div class="le-step-content">
    <div class="le-form-container" [class.wide-labels]="detailsService.hasWideLabels$ | async">
      <mydocma-dynamic-form
        [formConfig]="detailsService?.formConfig$ |async"
        (ready)="this.detailsService.attachToForm($event)">
      </mydocma-dynamic-form>
    </div>
  </div>
</div>
